// Blog Page
export default function Blog() { return <div><h1 className="text-4xl font-bold text-center py-20">Blog</h1><p className="text-center">News and articles from Elite Gymnastics.</p></div>; }